import { Component, OnInit, Input, forwardRef, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DocumentsManagerService } from 'core/services/documents-manager.service';
const MIMETYPES = ['application/pdf'];
@Component({
  selector: 'lms-documents-uploader',
  templateUrl: './documents-uploader.component.html',
  styleUrls: ['./documents-uploader.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DocumentsUploaderComponent),
      multi: true
    }
  ]
})
export class DocumentsUploaderComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() bannerUrl: any;
  @Input() accept: string = 'application/pdf';
  @Input() maxSizeInMB: number;
  @Input() disabled: boolean;
  @Input() id: string = 'uploadLargeImg';
  @Output() documentSelected: EventEmitter<any | any[]> = new EventEmitter<any>();

  public previewFile: boolean;
  public document: any;

  public propagateChange = (_: any) => {};
  public propagateTouched = (_: any) => {};

  constructor(public documentsManagerService: DocumentsManagerService) {}

  writeValue(value: any) {
    if (value && typeof value === 'string') {
      this.document = {
        name: value
      };
    } else {
      this.document = value;
    }
    this.previewFile = !!value;
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn) {
    this.propagateTouched = fn;
  }

  ngOnInit() {}

  ngOnDestroy() {}

  onGetFile(event: any) {
    const selectedFile = event[0] ? event[0] : event.target.files[0];
    if (MIMETYPES.includes(selectedFile.type)) {
      this.document = selectedFile;
      this.previewFile = true;
      this.propagateChange(this.document);
      this.documentSelected.next(this.document);
    } else {
      this.deleteDocument();
    }
  }

  deleteDocument() {
    this.previewFile = false;
    this.document = null;
    this.propagateChange(null);
    this.documentSelected.next(null);
  }
}
